"use strict";
/**
 * @module Services.Control
 */
var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
var conversation_id_serialiser_1 = require("./../../conversation/conversation-id-serialiser");
var Codec = require("./../../io/codec");
var serialiser_1 = require("./../../serialisers/serialiser");
/**
 * Serialiser for {@link MessagingFilterSendRequest}
 */
var MessagingFilterSendRequestSerialiserClass = /** @class */ (function (_super) {
    __extends(MessagingFilterSendRequestSerialiserClass, _super);
    function MessagingFilterSendRequestSerialiserClass() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    /**
     * Write a {@link MessagingFilterSendRequest} to the stream
     *
     * @param bos    the output stream
     * @param value  the {@link MessagingFilterSendRequest} to be written
     */
    MessagingFilterSendRequestSerialiserClass.prototype.write = function (bos, value) {
        conversation_id_serialiser_1.CIDSerialiser.write(bos, value.cid);
        Codec.writeString(bos, value.filter);
        Codec.writeString(bos, value.path);
        Codec.writeString(bos, value.dataType.name());
        Codec.writeBytes(bos, value.request);
    };
    return MessagingFilterSendRequestSerialiserClass;
}(serialiser_1.AbstractSerialiser));
exports.MessagingFilterSendRequestSerialiserClass = MessagingFilterSendRequestSerialiserClass;
/**
 * The {@link MessagingFilterSendRequestSerialiser} singleton
 */ // tslint:disable-next-line:variable-name
exports.MessagingFilterSendRequestSerialiser = new MessagingFilterSendRequestSerialiserClass();



//////////////////
// WEBPACK FOOTER
// ./~/diffusion/src/internal/services/control/messaging-filter-send-request-serialiser.js
// module id = 1904
// module chunks = 1